import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', padding: "0 25px", overflowWrap: 'break-word' }}>
				<h3 style={{textAlign:'center'}}>PA Cancelled Successfully</h3>
				<hr/>
				<p>Prior Authorization number {this.props.data.PANumber} has been cancelled.</p>		
			</div>
		);	
	}
}